import { flexRender,
    getCoreRowModel,
    useReactTable, } from '@tanstack/react-table';
import iBS03R_ResultType from '../model/iBS03R_ResultType';

type propsType = {
    sensorlogs: iBS03R_ResultType[]
}

const SensorLog_iBS03R_Result = (props: propsType) => {
    const data: iBS03R_ResultType[] = props.sensorlogs;

    const columns = [
        { header: "no", accessorKey: "no" },
        { header: "app_id", accessorKey: "app_id" },
        { header: "manufacturer_id", accessorKey: "manufacturer_id" },
        { header: "model", accessorKey: "model" },
        { header: "battery", accessorKey: "battery" },
        { header: "button", accessorKey: "button" },
        { header: "distance", accessorKey: "distance" },
        { header: "macaddress", accessorKey: "macaddress" },
        { header: "rssi", accessorKey: "rssi" },
        { header: "detected", accessorKey: "detected" },
        { header: "arrived", accessorKey: "arrived" }
      ];
      
    const table = useReactTable({columns, data, getCoreRowModel: getCoreRowModel()})
    return (
        <div>
            <p className='mx-3'>項目の表示・非表示</p>
            <div id='colVisible' className="px-1 mx-3">
                {table.getAllLeafColumns().map(column => {
                return (
                <label className='mx-3'>
                    <input
                    {...{
                        type: 'checkbox',
                        checked: column.getIsVisible(),
                        onChange: column.getToggleVisibilityHandler(),
                    }}
                    />{' '}
                    {column.id}
                </label>
                )
                })}
            </div>

            <div className='dataScroll'>
                <table>
                    <thead>
                    {table.getHeaderGroups().map((headerGroup) => (
                        <tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => (
                            <th key={header.id}>
                            {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                            </th>
                        ))}
                        </tr>
                    ))}
                    </thead>
                    <tbody>
                    {table.getRowModel().rows.map((row) => (
                        <tr key={row.id}>
                        {row.getVisibleCells().map((cell) => (
                            <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                        ))}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

        </div>
    )
}

export default SensorLog_iBS03R_Result